module.exports = __webpack_public_path__ + "media/images/abv_icon-f89cee21463c1b6c7a85a28e59f2f89b.svg";